import { MOBILE_WIDTH_PX } from "../const/const";

export type UseWidthResult = {
  isMobileWidth: boolean;
  isDesktopWidth: boolean;
  screenWidth: number;
};

export const useWidth = (): UseWidthResult => {
  const screenWidth = window.innerWidth;

  const views = {
    isMobileWidth: false,
    isDesktopWidth: false,
  };

  if (screenWidth <= MOBILE_WIDTH_PX) {
    return { ...views, isMobileWidth: true, screenWidth };
  }
  return { ...views, isDesktopWidth: true, screenWidth };
};
